import React from 'react';
import { ColumnType } from '../utils/type';

interface FooterProps<T> {
  rows: T[];
  columns: ColumnType<T>[];
}

export function Footer<T>({ rows, columns }: FooterProps<T>) {
  const summableIndexes = columns.map((c, i) => (c.summable ? i : -1)).filter((i) => i !== -1);

  if (summableIndexes.length === 0) return null;

  const firstSummable = summableIndexes[0];
  const lastSummable = summableIndexes[summableIndexes.length - 1];

  return (
    <tfoot className="sticky-bottom z-index-0">
      <tr>
        {columns.map((column, idx) => {
          const borderRadiusStyle: React.CSSProperties = {};

          if (idx === firstSummable) {
            borderRadiusStyle.borderBottomLeftRadius = '15px';
          }

          if (idx === lastSummable) {
            borderRadiusStyle.borderBottomRightRadius = '15px';
          }
          if (!column.summable) {
            return (
              <td
                key={idx}
                className="bg-footer-dtt"
                style={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 9,
                  borderTop: '2px solid #ccc'
                }}
              />
            );
          }
          const sum = rows.reduce((acc, row) => {
            const value = Number(column.selector?.(row));
            return acc + (Number.isFinite(value) ? value : 0);
          }, 0);

          return (
            <td
              key={idx}
              className={`fw-bolder fs-4 ${
                column.center ? 'text-center' : ''
              } thead-light-foot bg-dtt space-foot-dtt`}
              style={{
                position: 'sticky',
                bottom: 0,
                zIndex: 10,
                borderTop: '2px solid #ccc',
                ...borderRadiusStyle
              }}
            >
              {sum.toLocaleString()}
            </td>
          );
        })}
      </tr>
    </tfoot>
  );
}
